import { useState } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';

const formatNumber = (value) => parseFloat(value || 0).toLocaleString(navigator.language, { minimumFractionDigits: 3 });

const EmissionsDisaggregatedByFacilityRow = ({ facility, facilityID, facilityData, organisations }) => {
  const [expandedRows, setExpandedRows] = useState(new Set());
  const toggleRow = (id) => {
    setExpandedRows((prevExpandedRows) => {
      const newExpandedRows = new Set(prevExpandedRows);
      if (newExpandedRows.has(id)) {
        newExpandedRows.delete(id);
      } else {
        newExpandedRows.add(id);
      }
      return newExpandedRows;
    });
  };
  return (
    <tr>
      <td className='text-left px-[10px]'>{facility && facility.name}</td>
      <td className='text-center px-[10px]'>
        {organisations && organisations?.find((item) => item.id === facility?.organisationId)?.name}
      </td>
      <td className='text-right px-[10px]'>
        <div className='hidden sm:block text-right'>
          <span className='toggle-location'>
            {formatNumber(facilityData && facilityData.co2e ? facilityData.co2e.toFixed(3) : '0.000')}
          </span>
          <span className='toggle-market'>
            {formatNumber(
              facilityData && facilityData.marketScope ? _.sum(Object.values(facilityData.marketScope)) : '0.000',
            )}
          </span>
        </div>
        <div className='flex sm:hidden flex-col justify-end'>
          <span className='toggle-location'>
            {formatNumber(facilityData && facilityData.co2e ? facilityData.co2e.toFixed(3) : '0.000')}
          </span>
          <span className='toggle-market'>
            {formatNumber(
              facilityData && facilityData.marketScope ? _.sum(Object.values(facilityData.marketScope)) : '0.000',
            )}
          </span>
          <button className='text-xs text-primary underline mt-1 text-right' onClick={() => toggleRow(facilityID)}>
            {expandedRows.has(facilityID) ? 'Hide Details' : 'View Details'}
          </button>
          {expandedRows.has(facilityID) && (
            <div className='usage-detail normal-case text-muted-foreground'>
              <span className='toggle-location'>
                <p>
                  Scope 1 (tCO2e):{' '}
                  {formatNumber(facilityData && facilityData.scope[1] ? facilityData.scope[1].toFixed(3) : '0.000')}
                </p>
                <p>
                  Scope 2 (tCO2e):{' '}
                  {formatNumber(facilityData && facilityData.scope[2] ? facilityData.scope[2].toFixed(3) : '0.000')}
                </p>
                <p>
                  Scope 3 (tCO2e incl. WTT*):{' '}
                  {formatNumber(facilityData && facilityData.scope[3] ? facilityData.scope[3].toFixed(3) : '0.000')}
                </p>
              </span>
              <span className='toggle-market'>
                <p>
                  Scope 1 (tCO2e):{' '}
                  {formatNumber(
                    facilityData && facilityData.marketScope[1]
                      ? facilityData.marketScope[1].toFixed(3)
                      : facilityData && facilityData.scope[1]
                        ? facilityData.scope[1].toFixed(3)
                        : '0.000',
                  )}
                </p>
                <p>
                  Scope 2 (tCO2e):{' '}
                  {formatNumber(
                    facilityData && facilityData.marketScope[2] ? facilityData.marketScope[2].toFixed(3) : '0.000',
                  )}
                </p>
                <p>
                  Scope 3 (tCO2e incl. WTT*):{' '}
                  {formatNumber(
                    facilityData && facilityData.marketScope[3] ? facilityData.marketScope[3].toFixed(3) : '0.000',
                  )}
                </p>
              </span>
            </div>
          )}
        </div>
      </td>
      <td className='hidden sm:table-cell text-right px-[10px]'>
        <span className='toggle-location'>
          {formatNumber(facilityData && facilityData.scope[1] ? facilityData.scope[1].toFixed(3) : '0.000')}
        </span>
        <span className='toggle-market'>
          {formatNumber(
            facilityData && facilityData.marketScope[1]
              ? facilityData.marketScope[1].toFixed(3)
              : facilityData && facilityData.scope[1]
                ? facilityData.scope[1].toFixed(3)
                : '0.000',
          )}
        </span>
      </td>
      <td className='hidden sm:table-cell text-right px-[10px]'>
        <span className='toggle-location'>
          {formatNumber(facilityData && facilityData.scope[2] ? facilityData.scope[2].toFixed(3) : '0.000')}
        </span>
        <span className='toggle-market'>
          {formatNumber(facilityData && facilityData.marketScope[2] ? facilityData.marketScope[2].toFixed(3) : '0.000')}
        </span>
      </td>
      <td className='hidden sm:table-cell text-right px-[10px]'>
        <span className='toggle-location'>
          {formatNumber(facilityData && facilityData.scope[3] ? facilityData.scope[3].toFixed(3) : '0.000')}
        </span>
        <span className='toggle-market'>
          {formatNumber(facilityData && facilityData.marketScope[3] ? facilityData.marketScope[3].toFixed(3) : '0.000')}
        </span>
      </td>
    </tr>
  );
};

const mapStateToProps = (state, ownProps) => {
  const { emissionsByFacility } = state.consumption;
  const adminOrgs = state.admin?.organisations;
  const orgnaisationList = state.organisation?.list;
  const { cyfAdmin, whiteLabelAdmin } = state.profile?.details || {};
  const adminUser = cyfAdmin || whiteLabelAdmin || false;

  const { facilityID } = ownProps;

  const facilityData =
    state.report &&
    state.report.details &&
    state.report.details.year &&
    emissionsByFacility[state.report.details.year] &&
    emissionsByFacility[state.report.details.year][facilityID];
  const facility =
    emissionsByFacility &&
    state?.facility?.hierarchyFacilities &&
    _.uniqBy(state.facility?.hierarchyFacilities, 'id')?.find((item) => item.id === facilityID);

  return {
    facilityData,
    facility,
    organisations: adminUser ? adminOrgs : orgnaisationList,
  };
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(EmissionsDisaggregatedByFacilityRow);
